import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SidebarSettingsLayout from "../components/Shared/SidebarSettingsLayout";
import PersonalInformationForm from "../components/Settings/Account/PersonalInformationForm";
import DisplayPreferencesForm from "../components/Settings/Account/DisplayPreferencesForm";
import ChangePasswordForm from "../components/Settings/Account/ChangePasswordForm";
import LogoutSessionsForm from "../components/Settings/Account/LogoutSessionsForm";
import DeleteAccountForm from "../components/Settings/Account/DeleteAccountForm";
import CalendarFeedForm from "../components/Settings/CalendarFeed/CalendarFeedForm";

const groups = [
  { id: "profile", label: "Profile" },
  { id: "security", label: "Security" },
  { id: "integrations", label: "Integrations" },
  { id: "danger", label: "Danger Zone" },
];

const sections = [
  {
    id: "name-email",
    title: "Name & Email",
    description:
      "Update your name and email address. Your email address is also used to sign in to your account.",
    group: "profile",
    content: <PersonalInformationForm />,
    padding: "py-10",
  },
  {
    id: "display-preferences",
    title: "Display Preferences",
    description:
      "Customize how currency and time are displayed throughout the application.",
    group: "profile",
    content: <DisplayPreferencesForm />,
    padding: "py-10",
  },
  {
    id: "change-password",
    title: "Change Password",
    description: "Update the password associated with your account.",
    group: "security",
    content: <ChangePasswordForm />,
    padding: "py-10",
  },
  {
    id: "logout-sessions",
    title: "Log Out All Sessions",
    description:
      "Enter your password to log out of all active sessions across all devices. You will be signed out of this session as well and redirected to the sign-in page.",
    group: "security",
    content: <LogoutSessionsForm />,
    padding: "py-10",
  },
  {
    id: "calendar-feed",
    title: "Calendar Feed",
    description:
      "Subscribe to your schedule from Google, Apple, or Outlook Calendar.",
    group: "integrations",
    content: <CalendarFeedForm />,
    padding: "py-10",
  },
  {
    id: "close-account",
    title: "Close Account",
    description:
      "Close your account. Your data is retained and can be restored by contacting support.",
    group: "danger",
    content: <DeleteAccountForm />,
    padding: "py-10",
  },
];

const SettingsPage = () => {
  const { tab } = useParams();
  const navigate = useNavigate();

  // Backward compat: redirect old tab URLs
  useEffect(() => {
    if (tab === "account") {
      navigate("/settings", { replace: true });
    } else if (tab) {
      navigate("/settings", { replace: true });
    }
  }, [tab, navigate]);

  return <SidebarSettingsLayout groups={groups} sections={sections} />;
};

export default SettingsPage;
